/**
 * discount-url-sync.js
 * Applies ANY discount code from URL (/discount/CODE)
 * directly to the Shopify cart so it appears in the cart drawer.
 */

(function () {
  const STORAGE_KEY = 'sonder_discount_code';
  const MAX_DAYS = 7;

  function clean(code) {
    if (!code) return '';
    return String(code).trim().replace(/[^A-Za-z0-9_-]/g, '');
  }

  function getDiscountFromURL() {
    const path = window.location.pathname;
    const match = path.match(/\/discount\/([^/?]+)/i);
    if (match && match[1]) return match[1];

    const params = new URLSearchParams(window.location.search);
    return (
      params.get('discount') ||
      params.get('discount_code') ||
      params.get('coupon') ||
      ''
    );
  }

  function save(code) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ code, ts: Date.now() })
      );
    } catch (e) {}
  }

  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return '';
      const data = JSON.parse(raw);
      if (!data.code) return '';
      if (Date.now() - data.ts > MAX_DAYS * 864e5) return '';
      return data.code;
    } catch (e) {
      return '';
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount_codes: [code] }),
    }).then(r => r.json());
  }

  async function run() {
    let code = clean(getDiscountFromURL()) || clean(load());
    if (!code) return;

    save(code);

    const cart = await getCart();
    const existing = (cart.discount_codes || []).map(d => d.code?.toLowerCase());

    if (existing.includes(code.toLowerCase())) return;

    const updated = await applyDiscount(code);

    document.dispatchEvent(
      new CustomEvent('discount:update', {
        bubbles: true,
        detail: { resource: updated },
      })
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
